import { API_BASE_URL } from '../config/api.config';
import {
  CLOUDINARY_ADMIN_WIDTH,
  cloudinaryDeliveryUrl,
} from './cloudinaryDelivery';

/**
 * URL d'affichage pour la première image produit / prestation.
 * Applique une livraison Cloudinary optimisée (largeur adaptée au rendu).
 *
 * @param {object} item
 * @param {{ width?: number }} [options]
 */
export function getProductImageUrl(item, options = {}) {
  if (!item) return null;
  const raw =
    item.imageUrl ||
    (Array.isArray(item.images) && item.images.length > 0 && item.images[0]) ||
    item.image ||
    (Array.isArray(item.photos) && item.photos.length > 0 && item.photos[0]) ||
    null;
  if (!raw || typeof raw !== 'string') return null;

  let resolved = raw;
  if (raw.startsWith('/')) {
    const fromEnv = import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, '');
    const fromConfig = API_BASE_URL?.startsWith('/')
      ? (typeof window !== 'undefined' ? window.location.origin : '')
      : API_BASE_URL?.replace(/\/api\/?$/, '');
    const api = fromEnv || fromConfig || '';
    resolved = api ? `${api}${raw}` : raw;
  } else if (!(raw.startsWith('http://') || raw.startsWith('https://'))) {
    resolved = raw;
  }

  const width = options.width ?? CLOUDINARY_ADMIN_WIDTH.tile;
  return cloudinaryDeliveryUrl(resolved, { width }) || resolved;
}
